import { render, staticRenderFns } from "./agreementWarning.vue?vue&type=template&id=4b69c084&"
import script from "./agreementWarning.vue?vue&type=script&lang=js&"
export * from "./agreementWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports